import React from 'react';
import PropTypes from 'prop-types';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';
import LightBox from '@bd/bdui-lightbox';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageSectionHeading from '../../PageSectionHeading';

import { colors } from '../../../styles';

const styles = css`
  padding:45px 0;
  @media (min-width: 991px) {
    padding:90px 0;
  }
.Testimonials_list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}
.Testimonials_listItem {
  width: 100%;
  background-color: ${colors.neutralLight};
  padding: 90px 60px;
  background-image: url('/images/icon-quotes-white.svg');
  background-position: 60px -10px;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 0 0 45px 0;
  @media (min-width: 1200px) {
    width: 38%;
  }
  &:nth-child(4n+0), &:nth-child(4n+1) {
    width: 100%;
    background-color: rgba(3, 107, 67, 0.2);
    @media (min-width: 1200px) {
      width: 58%;
    }
    .Testimonials_body p {
      font-size: 24px;
      margin: 0 0 30px 0;
    }
  }
}
.Testimonials_body {
  display: block;
  width: 100%;
}
.Testimonials_body p {
  font-size: 20px;
  line-height: 1.5;
  margin: 0 0 30px 0;
}
.Testimonials_credit {
  font-size: 16px;
  font-weight: 800;
  margin: 0 0 0 0;
}
.Testimonial_image {
  width: 100%;
  position: relative;
  z-index: 1;
  margin: 0 0 15px 0;
}
.Testimonial_imageWrapper {
  width: 100%;
  position: relative;
  justify-content: center;
  align-items: center;
  @media (min-width: 992px) {
    margin: 0;
  }
}
.Testimonial_videoButton {
  cursor: pointer;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 15px;
  background-image: url('/images/icon-play-button-white.svg');
  background-position: center center;
  background-size: 90px 90px;
  background-repeat: no-repeat;
  display: block;
  z-index: 2;
}
`;

const videoCss = css`
  margin: 10vh auto 0;
  @media (min-width: 992px) {
    width: 75vw;
    margin: 10vh auto 0;
  }
`;

function PageTestimonials({ content }) {
  return (
    <div className={styles}>
      {
        get(content, '[0].section_heading') &&
        <PageSectionHeading h3={get(content, '[0].section_heading')} />
      }
      <div className="container">
        <div className="row">
          <ul className="Testimonials_list">
            {
              get(content, '[0].testimonials', []).map(testimonial => (
                <li key={testimonial._id} className="Testimonials_listItem">
                  <div className="w-100">
                    {
                      get(testimonial, 'photo.contentUrl') &&
                      <div
                        className="Testimonial_imageWrapper"
                      >
                        <Image
                          src={get(testimonial, 'photo.contentUrl')}
                          width={1200}
                          height={1200}
                          className="Testimonial_image"
                          alt={get(testimonial, 'photo.name', get(testimonial, 'photo.caption', ''))}
                        />
                        {
                          get(testimonial, 'video') &&
                          <LightBox
                            enableZoom
                            items={[
                              {
                                element: (
                                  <div
                                    className={`${videoCss} embed-responsive embed-responsive-16by9`}
                                    dangerouslySetInnerHTML={SanitizeHtml(get(content, '[0].video'))}
                                  />
                                ),
                              },
                            ]}
                          >
                            <span className="Testimonial_videoButton" role="button" tabIndex="0" />
                          </LightBox>
                        }
                      </div>
                    }
                    <div className="Testimonials_body" dangerouslySetInnerHTML={SanitizeHtml(testimonial.message)} />
                    <h4 className="Testimonials_credit">
                      {
                        [
                          testimonial.name,
                          testimonial.location,
                        ].filter(v => v).join(' | ')
                      }
                    </h4>
                  </div>
                </li>
              ))
            }
          </ul>
        </div>
      </div>
    </div>
  );
}

PageTestimonials.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};
PageTestimonials.defaultProps = {
};

export default PageTestimonials;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/PageTestimonials.section.js